export const TOKENS = {
  // Card and Container Backgrounds
  bgCard: 'bg-surface',
  bgApp: 'bg-background',
  bgMuted: 'bg-surface-raised',
  bgActive: 'bg-surface-hover',

  // Borders
  border: 'border border-border',
  borderMuted: 'border border-border/60',
  borderInteractive: 'border-border hover:border-border-strong focus:border-accent',

  // Common interactive element classes
  input: 'w-full bg-surface-raised border border-border rounded-xl px-4 py-2.5 text-sm text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/20 focus:border-accent transition-all placeholder-foreground-subtle',
  select: 'bg-surface-raised border border-border rounded-xl px-2.5 py-1.5 text-xs font-semibold focus-visible:outline-none text-foreground focus-visible:ring-2 focus-visible:ring-accent/20 focus:border-accent',

  // Text Colors
  textHeading: 'text-foreground font-semibold',
  textBody: 'text-foreground/90',
  textSecondary: 'text-foreground-muted',
  textMuted: 'text-foreground-subtle',

  // Hover states
  hoverRow: 'hover:bg-surface-hover transition-colors',
  hoverItem: 'hover:bg-surface-hover transition-colors',

  // Brand amber. It is a background colour: white on it is 2.52:1, so text on
  // amber is dark in both themes. Pair it this way rather than putting
  // text-white on bg-accent. text-accent is amber used as text, and is already
  // darkened for light surfaces by tailwind.config.ts.
  onAccent: 'bg-accent text-accent-foreground hover:bg-accent-strong',
}
